
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DownloadIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Badge } from "types";
import { useNavigate } from "../../services";

type IShare = {
  badge: Badge | undefined
  certificates: Badge[] | undefined
  iconOnly?: boolean
}

export const Download = (
  { badge, certificates, iconOnly = false }:IShare
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down("sm"));

  const hasEnabledBadge = !!badge?.isEnable;
  const hasEnabledCertificate = !!certificates?.some(c => c?.isEnable);

  return (
    <Box
      id="content-detail-download-button"
      data-testid="content-detail-download-button"
      role="button"
      className="button"
      aria-label={ t("download") }
      tabIndex={ 0 }
      position={ "relative" }
      sx={ {
        alignItems: "center",
        cursor: (hasEnabledBadge || hasEnabledCertificate) ? "pointer" :"not-allowed",
        display: "flex",
        gap: "0.5rem",
        justifyContent: "center",
        padding: "1rem 0.75rem",
        
        "&:hover": {
          backgroundColor: 
          (hasEnabledBadge || hasEnabledCertificate) 
            ? theme.customColors.backgroundSecondaryCtaHover 
            :  theme.customColors.backgroundPrimary,
          borderBottomRightRadius: "inherit",
          borderTopRightRadius: "inherit",
          transition: "all 0.35s ease-out"
        }
      } }
      alignItems="center"
      
      onClick={ (e)=> {
        if(hasEnabledBadge || hasEnabledCertificate){
          e.preventDefault();
          navigate("/profile");
        } else {
          e.preventDefault();
        }
      } } 
      onKeyDown={ (e) => {
        if((hasEnabledBadge || hasEnabledCertificate) && (e.key === "Enter" || e.key === " ")){
          e.preventDefault();
          navigate("/profile");
        }
      } }
    >
      <DownloadIcon size={ "1rem" } />
      { !isMedium && !iconOnly && (
        <Typography fontSize={ "0.875rem" }>
          { t("Download") }
        </Typography>
      ) }
    </Box>
  );
};
